webpackJsonp([5],{

/***/ 712:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(776);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71f381ae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(797);
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71f381ae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 738:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return capitalize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return titleize; });
var _titleizeWord = function _titleizeWord(string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};
var capitalize = function capitalize(str) {
  var lower = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return (lower ? str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, function (match) {
    return match.toUpperCase();
  });
};

var titleize = function titleize(sentence) {
  if (!sentence.split) {
    return _titleizeWord(sentence);
  }
  var result = [];
  sentence.split('_').forEach(function (w) {
    result.push(_titleizeWord(w));
  });
  return result.join('');
};

/***/ }),

/***/ 776:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_profile_index__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chi_x_chi_login_lib_actions__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_ReactNative__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_helper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__analytics__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_underscore__ = __webpack_require__(12);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Profile',
  created: function created() {
    this.loading = true;
    this.callProfileAction();
  },
  data: function data() {
    return {
      roleRelative: true
    };
  },


  components: { profile: __WEBPACK_IMPORTED_MODULE_2__components_profile_index__["a" /* default */] },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getProfileData']), {
    styles: function styles() {
      var result = Object(__WEBPACK_IMPORTED_MODULE_5__helper_helper__["b" /* convertEmToPixels */])(19);
      return {
        'font-size': result + 'px',
        'line-height': result + 2 + 'px',
        'font-weight': '400'
      };
    },
    hasRelativeRole: function hasRelativeRole() {
      var roles = this.getProfileData.roles;

      return roles && __WEBPACK_IMPORTED_MODULE_7_vue_underscore__["a" /* _ */].indexOf(roles, 'relative') >= 0;
    },
    dataProfile: function dataProfile() {
      return this.getProfileData;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    profileAction: 'GET_PROFILE',
    favAction: 'GET_FAVS',
    resetAuthor: 'RESET_AUTHORS_ACTION',
    resetFavs: 'RESET_LIKES_ACTION',
    resetLikes: 'RESET_LIKES_ACTION',
    resetNotifications: 'RESET_NOTIFS_ACTION',
    resetPosts: 'RESET_POSTS_ACTION',
    resetProfile: 'RESET_PROFILE_ACTION',
    resetShares: 'RESET_SHARES_ACTION',
    resetSystem: 'RESET_SYSTEM_ACTION',
    resetTags: 'RESET_TAGS_ACTION',
    resetVideos: 'RESET_VIDEOS_ACTION',
    resetDevices: 'RESET_DEVICES_ACTION',
    update_realtime: 'UPDATE_DEVICE'
  }), {
    callProfileAction: function callProfileAction() {
      var _this = this;

      this.profileAction().then(function () {
        return _this.loading = false;
      });
    },
    logOut: function logOut() {
      Object(__WEBPACK_IMPORTED_MODULE_6__analytics__["a" /* RegisterEvent */])('chi_user_logout', {
        target_id: 'logout',
        target_type: 'global_event'
      });
      this.update_realtime();
      var dispatchLogout = this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__chi_x_chi_login_lib_actions__["a" /* default */].AUTH_LOGOUT);
      this.resetAuthor();
      this.resetFavs();
      this.resetLikes();
      this.resetNotifications();
      this.resetPosts();
      this.resetProfile();
      this.resetShares();
      this.resetSystem();
      this.resetTags();
      this.resetVideos();
      this.resetDevices();
      return dispatchLogout;
    },
    goToPage: function goToPage(pageName) {
      Object(__WEBPACK_IMPORTED_MODULE_6__analytics__["a" /* RegisterEvent */])('chi_menu_selected', {
        target_id: pageName,
        target_type: 'menu_name'
      });
      return this.$router.push({ name: pageName });
    },
    onLinkClick: function onLinkClick(link) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_ReactNative__["c" /* openLink */])(link);
      Object(__WEBPACK_IMPORTED_MODULE_6__analytics__["a" /* RegisterEvent */])('chi_url_open', {
        target_id: link.uri,
        target_type: 'link'
      });
    }
  })
});

/***/ }),

/***/ 777:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_index_js__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_helper__ = __webpack_require__(31);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'profile-component',
  props: {
    index: {
      // index of current item
      type: Number
    },
    source: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    styles: function styles() {
      var result = Object(__WEBPACK_IMPORTED_MODULE_1__helper_helper__["b" /* convertEmToPixels */])(19);
      return {
        'font-size': result + 'px',
        'line-height': result + 2 + 'px'
      };
    },
    stylesMinor: function stylesMinor() {
      var result = Object(__WEBPACK_IMPORTED_MODULE_1__helper_helper__["b" /* convertEmToPixels */])(16);
      return {
        'font-size': result + 'px',
        'line-height': result + 2 + 'px'
      };
    }
  },
  methods: {
    fullName: function fullName() {
      return (Object(__WEBPACK_IMPORTED_MODULE_0__helper_index_js__["a" /* capitalize */])(this.source.name) || '') + ' ' + (Object(__WEBPACK_IMPORTED_MODULE_0__helper_index_js__["a" /* capitalize */])(this.source.surname) || '');
    }
  }
});

/***/ }),

/***/ 793:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(777);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_028714dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(794);
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_028714dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 794:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"user",staticClass:"user-info-wrapper",attrs:{"tabindex":"0"}},[_c('div',{staticClass:"person"},[_c('v-avatar',{staticClass:"avatar-profile",attrs:{"size":"66"}},[_c('img',{staticClass:"avatar-image",attrs:{"src":_vm.source.avatar_uri || __webpack_require__(396)}})]),_vm._v(" "),_c('div',{},[_c('div',{staticClass:"inline"},[_c('b',{staticClass:"nameType",style:(_vm.styles)},[_vm._v(_vm._s(_vm.fullName()))])]),_vm._v(" "),_c('div',{staticClass:"inline"},[_c('img',{staticClass:"email-icon",attrs:{"src":__webpack_require__(795)}}),_vm._v(" "),_c('span',{staticClass:"text-style",style:(_vm.stylesMinor)},[_vm._v(_vm._s(_vm.source.email || ''))])]),_vm._v(" "),_c('div',{staticClass:"inline"},[_c('img',{staticClass:"phone-icon",attrs:{"src":__webpack_require__(796)}}),_vm._v(" "),_c('span',{staticClass:"text-style",style:(_vm.stylesMinor)},[_vm._v(_vm._s(_vm.source.phone || ''))])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 795:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAeCAYAAABE4bxTAAAAAXNSR0IArs4c6QAAA4dJREFUWAntls9LVFEUx+c9R8zQfmK2adFkIfQTZ1TEKTWKfo21iqhNBC5Es5CwNkWT7Sqiop/Qoh9U0KZEKzBzk4rjjP0B4aJaVJBBoIuxcWb6nNe7j3EaHZ30tenAmXvuuefH95577n2jxeNxzePxNDkcjqNwEazBdlKcZEO6rt8YGBi4prnd7mMortqJYLJcmqY1O1mUyggNw09RRo2ZfT86p7SfdMvgJgEkx+QASHsoFGoU2W7ilKRNGgDm0hFUz6ywG4jKRzEKlSyAFFWCdKGa2DVWVFTkUpktKp8FCGUuynq1YNcYiUSkhwtUPguQKCidnydgnVqc67G0tHQTOVoT80wARJXmsdjF0a1PNJoLGTBryffKzGmlSAT0Q7QYFFKpHiq1z7KaZYHYe2OxWC+5lpuhjdwiW4AA8RC+IEoMF8DP2MV5v99v2cja35DEovqtxH5OHHWBLiHfV3EnJOMdOgUoaeyfsMYuTnd0dLzwer2LlUOmY3V19SJiteN/RmLDkqNhcHCwhZzy+TBoAiDRAOqO0+msQvwsc3azMxwOh8rKyjbKPBOSnhwZGQkRa7fp/4VvVw1gbiXH+wOQGAQCgX4c3Ig9MieQKxqN9hH4kMxnQvTLQez74VXiRzV6iV0SDAb7ZJ5MKQGJEQ5fGbYS4LrpNJ/xEaCuUH755ExJYgOYy2zmMYbiK3STeY0Z+7cm6XdSQGJHSSMcYROgDsNh0/f46OhoF0e4NCmWNeX1XcIRdZK8WZTiS1WOEK9RYlqGKYQpASl7QD0geCXzj6JDrqLhg6n6qry8fAOvbxCzGrGFPmVlZXmpyj1jluKHeNLkBqUtvTJkZ+84Lg+7fUKAbfBK+irA03AxOzv77tjYmNyUuvHx8ZOMOaZfN+MBelL+2kyLplUhFQlQwz6fbweg/OhicI48DYD5gCzVkystYGSttba2drv4IE9JxLOu/bQrpCLyuEmycxzXWyp0G3m1WjNH+TtazxG9AUzSUvrpjCqUGI7/v91UoJjd7QHAWbNqPpfLVSxgEm3TyRn1UKqgZrVesiZsUCZVkSODDP+MK2Tmn/XhP6B0JZVb9g0u4Awreep3MUbTOc3mOhdC5+nYLDHppe8CqA2ug0sAYzUnc1sIMIl52vT8/PwWNJ2J2n8hU53XeXl5J6xvCA/dGtAWUSVLZwcwufKc2hDv2ns78s04xy8t4lstNNov8gAAAABJRU5ErkJggg=="

/***/ }),

/***/ 796:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 797:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profileContent"},[_c('div',{ref:"profileUser",staticClass:"actionList"},[_c('profile',{attrs:{"source":_vm.dataProfile}}),_vm._v(" "),_c('v-list-item',{staticClass:"config-item",attrs:{"color":"white"},on:{"click":function($event){return _vm.goToPage('Favs')}}},[_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"title ",staticStyle:{"color":"black"}},[_c('div',{style:(_vm.styles)},[_vm._v("Mis favoritos")])])],1),_vm._v(" "),_c('v-list-item-action',[_c('v-icon',{staticStyle:{"color":"gray"}},[_vm._v("mdi-chevron-right")])],1)],1),_vm._v(" "),(!_vm.hasRelativeRole)?_c('v-list-item',{staticClass:"config-item",attrs:{"source":_vm.dataProfile,"color":"white"},on:{"click":function($event){return _vm.goToPage('EditProfile')}}},[_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"title ",staticStyle:{"color":"black"}},[_c('div',{style:(_vm.styles)},[_vm._v("Editar perfil")])])],1),_vm._v(" "),_c('v-list-item-action',[_c('v-icon',{staticStyle:{"color":"gray"}},[_vm._v("mdi-chevron-right")])],1)],1):_vm._e(),_vm._v(" "),_c('v-list-item',{staticClass:"config-item",attrs:{"color":"white"},on:{"click":function($event){return _vm.onLinkClick({
          uri:
            'https://www.colegiohispanoingles.com/wp-content/uploads/2020/09/Reglamento_de_convivencia.pdf'
        })}}},[_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"title ",staticStyle:{"color":"black"}},[_c('div',{style:(_vm.styles)},[_vm._v("Reglamento interno")])])],1),_vm._v(" "),_c('v-list-item-action',[_c('v-icon',{staticStyle:{"color":"gray"}},[_vm._v("mdi-chevron-right")])],1)],1),_vm._v(" "),_c('div',{staticClass:"list-item-separator"}),_vm._v(" "),_c('v-list-item',{staticClass:"config-item close",attrs:{"color":"white"},on:{"click":_vm.logOut}},[_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"title ",staticStyle:{"color":"red"}},[_c('div',{style:(_vm.styles)},[_vm._v("Cerrar sesión")])])],1),_vm._v(" "),_c('v-list-item-action',[_c('v-icon',{staticStyle:{"color":"gray"}},[_vm._v("mdi-chevron-right")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/5.57f28b0a0907433b7980.js